'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataSet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataSet = exports.DataSet = (_temp = _class = function (_React$PureComponent) {
  _inherits(DataSet, _React$PureComponent);

  function DataSet(props, context) {
    _classCallCheck(this, DataSet);

    var _this = _possibleConstructorReturn(this, (DataSet.__proto__ || Object.getPrototypeOf(DataSet)).call(this, props, context));

    _this.handleResolve = function (value, params) {
      if (_this.props.spin) {
        _this.setState({
          pending: true
        });
      }
      if (_this.props.getResolver) {
        var resolver = _this.props.getResolver(value, params);
        resolver.then(function (iState) {
          iState.pending = false;
          _this.setState(iState, _this.props.onChange);
        });
      }
    };

    _this.state = {
      pending: props.spin
    };
    _this.stateUpdater = {};

    if (props.getResolver) {
      _this._resolver = props.getResolver(props.defaultValue);
    }
    /**
     * prop = {
     *  value: Object | Function,
     *  format: String,
     *  formatter: Function,
     *  setter: String | Function
     * }
     */
    Object.keys(props.data).forEach(function (name) {
      var prop = props.data[name];
      if (prop.value) {
        var originValue = typeof prop.value === 'function' ? prop.value.call(_this, _this.props) : prop.value;
        var formatter = _this.getFormatter(props.formatter, name);
        // formatter是一系列解决组件schema的格式化函数
        if (formatter) {
          _this.state[name] = formatter.call(_this, prop.schema, originValue);
        } else {
          _this.state[name] = originValue;
        }
      }
      if (prop.setter) {
        var setter = props.childProps[prop.setter];
        _this.stateUpdater[prop.setter] = function (updateFn) {
          return _this.setState(function (prevState) {
            var newValue = typeof updateFn === 'function' ? updateFn.call(_this, prevState[name]) : updateFn;
            var formatter = _this.getFormatter(props.formatter, name);
            if (formatter) {
              newValue = formatter.call(_this, prop.schema, newValue);
            }
            setter && setter(newValue);
            return _defineProperty({}, name, newValue);
          });
        };
      }
    });
    return _this;
  }

  _createClass(DataSet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this._resolver && this._resolver.then(function (iState) {
        iState.pending = false;
        _this2.setState(iState, _this2.props.onChange);
      });
    }
  }, {
    key: 'getFormatter',
    value: function getFormatter(formatter, name) {
      if (!formatter && DataSet.formatter) {
        var comFormatter = DataSet.formatter[this.props.format] || {};
        formatter = comFormatter[name];
      }
      return formatter;
    }
  }, {
    key: 'getRealInstance',
    value: function getRealInstance() {
      return this._instance;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var option = {};
      var _props = this.props,
          children = _props.children,
          Component = _props.Component,
          childProps = _props.childProps;

      var type = void 0;
      if (Component) {
        type = Component.name;
        if (type && DataSet.themeOptions[type]) {
          option = DataSet.themeOptions[type];
        }

        if (children) {
          return _react2.default.createElement(
            Component,
            _extends({
              ref: function ref(instance) {
                return _this3._instance = instance;
              }
            }, option, childProps, this.state, this.stateUpdater),
            children
          );
        } else {
          return _react2.default.createElement(Component, _extends({
            ref: function ref(instance) {
              return _this3._instance = instance;
            }
          }, option, childProps, this.state, this.stateUpdater));
        }
      } else {
        type = children.type.name;
        if (type && DataSet.themeOptions[type]) {
          option = DataSet.themeOptions[type];
        }
        return _react2.default.cloneElement(_react2.default.Children.only(children), _extends({
          ref: function ref(instance) {
            _this3._instance = instance;
            if (typeof children.ref === 'function') {
              children.ref(instance);
            }
          }
        }, option, childProps, this.state, this.stateUpdater));
      }
    }
  }]);

  return DataSet;
}(_react2.default.PureComponent), _class.formatter = {}, _class.themeOptions = {}, _class.theme = function (themeOptions) {
  DataSet.themeOptions = themeOptions;
}, _class.propTypes = {
  Component: _propTypes2.default.any,
  childProps: _propTypes2.default.object,
  onChange: _propTypes2.default.object,

  value: _propTypes2.default.any,
  data: _propTypes2.default.object,
  getResolver: _propTypes2.default.func,
  defaultValue: _propTypes2.default.string,
  format: _propTypes2.default.string,
  formatter: _propTypes2.default.func,
  children: _propTypes2.default.any,
  spin: _propTypes2.default.bool
}, _class.defaultProps = {
  data: {},
  childProps: {}
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/components/dataSet/index.jsx
// module id = 32
// module chunks = 0